/**
 * Formats a date string to a readable format
 * @param dateString - Date string to format
 * @returns Formatted date string (e.g., "Jan 27, 2026")
 */
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
